import { Link } from "react-router-dom";

import styled from "@emotion/styled";

export const Wrapper = styled.div`
  margin-bottom: 24px;
`;

export const Title = styled.p`
  padding-left: ${p => p.theme.space[6]}px;
  margin-bottom: ${p => p.theme.space[5]}px;

  font-size: 22px;
  font-weight: ${p => p.theme.fontWeight.semiBold};
  line-height: 125%;

  color: ${p => p.theme.colors.secondary.title};

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    margin-bottom: 20px;
    font-size: ${p => p.theme.fontSizes.xxl};
  }
`;

export const ProxyList = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
`;

export const ExploreLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  gap: ${p => p.theme.space[3]}px;

  font-size: 20px;
  font-weight: ${p => p.theme.fontWeight.medium};

  color: ${p => p.theme.colors.black};
  background-color: ${p => p.theme.colors.accent.green};

  border-radius: 24px;

  transition: background-color 0.3s ease-in-out;
  -webkit-tap-highlight-color: transparent;

  min-width: 148px;
  width: 100%;
  height: 104px;
  gap: 6px;

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    min-width: auto;
    max-width: 180px;
    width: 100%;
    height: 140px;

    gap: ${p => p.theme.space[3]}px;
  }

  :hover {
    border: 1px solid rgba(255, 255, 255, 0.32);
    background-color: ${p => p.theme.colors.hover.background};
  }
  :active {
    border: 1px solid rgba(255, 255, 255, 0.32);
    background-color: ${p => p.theme.colors.active.background};
  }
`;

export const Icon = styled.img`
  width: 24px;
  height: 24px;
`;
